import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03c88597"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ss-principais-acoes" }
const _hoisted_3 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Gerar", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "ss-card" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ss-card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-destaque" }, "Parâmetros do Relatório")
], -1))
const _hoisted_8 = { class: "ss-card-body" }
const _hoisted_9 = { class: "ss-form-grid" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_12 = { class: "ant-col ant-col ant-col-xs-24 ant-col-xl-14" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-14" }
const _hoisted_19 = {
  class: "ss-tela-conteudo",
  style: {"max-height":"calc(100vh - 400px)","overflow":"scroll"}
}
const _hoisted_20 = {
  key: 0,
  class: "ss-margin-tb-10"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Não há dados disponíveis para o relatório.", -1))
const _hoisted_22 = { class: "ss-card" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ss-card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-destaque" }, "Saldo Bancário")
], -1))
const _hoisted_24 = {
  class: "ss-card-body",
  style: {"max-width":"50%"}
}
const _hoisted_25 = {
  class: "ant-row ss-sombra-suave",
  style: {"min-height":"35px","padding-top":"5px"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-align-left" }, "Saldo Geral do Dia Utilizando os Limites", -1))
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }
const _hoisted_28 = {
  class: "ant-row ss-sombra-suave",
  style: {"min-height":"35px","padding-top":"5px"}
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-align-left" }, "Saldo Geral do Dia Sem os Limites", -1))
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }
const _hoisted_31 = { class: "ss-card" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-14 ss-card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-destaque" }, "Despesas Mensais")
], -1))
const _hoisted_33 = {
  class: "ss-card-body",
  style: {"max-width":"50%"}
}
const _hoisted_34 = { class: "ss-totalizador" }
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-align-left" }
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }
const _hoisted_37 = {
  class: "ant-row ss-sombra-suave",
  style: {"min-height":"35px","padding-top":"5px"}
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-totalizador ss-align-left",
  style: {"font-weight":"bolder"}
}, "Total Despesas Mês", -1))
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }
const _hoisted_40 = {
  class: "ant-row ss-sombra-suave",
  style: {"min-height":"35px","padding-top":"5px"}
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-totalizador ss-align-left",
  style: {"font-weight":"bolder"}
}, "Saldo Geral Sem Limites", -1))
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }
const _hoisted_43 = { class: "ss-card" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ss-card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-destaque" }, "Previsão de Recebimento")
], -1))
const _hoisted_45 = {
  class: "ss-card-body",
  style: {"max-width":"50%"}
}
const _hoisted_46 = {
  class: "ant-row ss-sombra-suave",
  style: {"min-height":"35px","padding-top":"5px"}
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-align-left" }, "Cob Simples", -1))
const _hoisted_48 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }
const _hoisted_49 = {
  class: "ant-row ss-sombra-suave",
  style: {"min-height":"35px","padding-top":"5px"}
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-align-left" }, "Pedidos Pendentes", -1))
const _hoisted_51 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }
const _hoisted_52 = {
  class: "ss-totalizador-destaque ant-row ss-sombra-suave",
  style: {"min-height":"35px","padding-top":"5px"}
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-totalizador ss-align-left",
  style: {"font-weight":"bolder"}
}, "Total Previsão Recebimento", -1))
const _hoisted_54 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }
const _hoisted_55 = { class: "ss-card" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ss-card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-destaque" }, "Duplicatas em Carteira")
], -1))
const _hoisted_57 = {
  class: "ss-card-body",
  style: {"max-width":"50%"}
}
const _hoisted_58 = { class: "ss-totalizador" }
const _hoisted_59 = {
  class: "ss-totalizador-destaque ant-row ss-sombra-suave",
  style: {"min-height":"35px","padding-top":"5px"}
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-align-left" }, "Em Carteira p/ Desconto 180", -1))
const _hoisted_61 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }
const _hoisted_62 = {
  class: "ss-totalizador-destaque ant-row ss-sombra-suave",
  style: {"min-height":"35px","padding-top":"5px"}
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-align-left" }, "Em Carteira p/ Desconto +180", -1))
const _hoisted_64 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }
const _hoisted_65 = {
  class: "ss-totalizador-destaque ant-row ss-sombra-suave",
  style: {"min-height":"35px","padding-top":"5px"}
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-totalizador ss-align-left",
  style: {"font-weight":"bolder"}
}, "Total Carteira p/ Desconto", -1))
const _hoisted_67 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }
const _hoisted_68 = {
  class: "ss-totalizador-destaque ant-row ss-sombra-suave",
  style: {"min-height":"35px","padding-top":"5px"}
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-totalizador ss-align-left",
  style: {"font-weight":"bolder"}
}, "Total Previsão Rec + DP em Carteira", -1))
const _hoisted_70 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }
const _hoisted_71 = {
  class: "ss-totalizador-destaque ant-row ss-sombra-suave",
  style: {"min-height":"35px","padding-top":"5px"}
}
const _hoisted_72 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-totalizador ss-align-left",
  style: {"font-weight":"bolder"}
}
const _hoisted_73 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }
const _hoisted_74 = { class: "ss-card" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ss-card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-destaque" }, "Despesas Futuras")
], -1))
const _hoisted_76 = {
  class: "ss-card-body",
  style: {"max-width":"50%"}
}
const _hoisted_77 = { class: "ss-totalizador" }
const _hoisted_78 = { class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-align-left" }
const _hoisted_79 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }
const _hoisted_80 = {
  class: "ss-totalizador-destaque ant-row ss-sombra-suave",
  style: {"min-height":"35px","padding-top":"5px"}
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-totalizador ss-align-left",
  style: {"font-weight":"bolder"}
}, "Total a Pagar", -1))
const _hoisted_82 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }
const _hoisted_83 = {
  class: "ss-totalizador-destaque ant-row ss-sombra-suave",
  style: {"min-height":"35px","padding-top":"5px"}
}
const _hoisted_84 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-totalizador ss-align-left",
  style: {"font-weight":"bolder"}
}
const _hoisted_85 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }
const _hoisted_86 = { class: "ss-card" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ss-card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-destaque" }, "Duplicatas em Carteira com Mais de 1 Ano")
], -1))
const _hoisted_88 = {
  class: "ss-card-body",
  style: {"max-width":"50%"}
}
const _hoisted_89 = { class: "ss-totalizador" }
const _hoisted_90 = {
  class: "ss-totalizador-destaque ant-row ss-sombra-suave",
  style: {"min-height":"35px","padding-top":"5px"}
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-align-left" }, "Faturados em Carteira com Mais de Um Ano de Vencimento", -1))
const _hoisted_92 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }
const _hoisted_93 = { class: "ss-card" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ss-card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-destaque" }, "Saldo Futuro")
], -1))
const _hoisted_95 = {
  class: "ss-card-body",
  style: {"max-width":"50%"}
}
const _hoisted_96 = { class: "ss-totalizador" }
const _hoisted_97 = {
  class: "ss-totalizador-destaque ant-row ss-sombra-suave",
  style: {"min-height":"35px","padding-top":"5px"}
}
const _hoisted_98 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-16 ss-totalizador ss-align-left",
  style: {"font-weight":"bolder"}
}
const _hoisted_99 = { class: "ant-col ant-col-xs-24 ant-col-xl-8 ss-totalizador-valor ss-align-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_titulo_padrao, {
        identificadorRecurso: _ctx.telaBase.identificadorRecurso,
        tituloRecurso: _ctx.telaBase.titulo,
        exibirAtalhosTela: true,
        exibirHistoricoTela: false,
        empresasSelecionadas: [_ctx.state.filtros?.empresa],
        empresasDisponiveis: _ctx.telaBase.empresasDisponiveis,
        permissaoDados: _ctx.telaBase.permissaoDados,
        onAtualizarSelecaoEmpresas: _ctx.atualizarSelecaoEmpresas,
        onSelecionarEmpresa: _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.filtros.empresa = $event))
      }, {
        BotoesAcoes: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "ant-btn ant-btn-secondary ss-btn-recursos",
                title: "Imprimir",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
              }, [
                _createVNode(_component_icone, { nome: "imprimir" })
              ]),
              _createElementVNode("button", {
                class: "ant-btn ant-btn-secondary ss-btn-recursos",
                title: "Exportar Word",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Word)))
              }, [
                _createVNode(_component_icone, { nome: "word" })
              ]),
              _createElementVNode("button", {
                class: "ant-btn ant-btn-secondary ss-btn-recursos",
                title: "Exportar Excel",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Excel)))
              }, [
                _createVNode(_component_icone, { nome: "excel" })
              ]),
              _createElementVNode("button", {
                class: "ant-btn ant-btn-secondary ss-btn-recursos",
                title: "Exportar CSV",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.CSV)))
              }, [
                _createVNode(_component_icone, { nome: "download-arquivo" })
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-primary ss-btn-tela",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.gerarRelatorio && _ctx.gerarRelatorio(...args)))
              }, _hoisted_5)
            ])
          ])
        ]),
        _: 1
      }, 8, ["identificadorRecurso", "tituloRecurso", "empresasSelecionadas", "empresasDisponiveis", "permissaoDados", "onAtualizarSelecaoEmpresas"]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_ctx.telaBase.empresasSelecionadas.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_a_form_item, {
                        label: "Empresa",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_empresa, {
                            codigoSelecionado: _ctx.state.filtros.empresa,
                            "onUpdate:codigoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.filtros.empresa) = $event))
                          }, null, 8, ["codigoSelecionado"])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_a_form, {
                class: "ss-alinhar-texto-esquerda",
                layout: "vertical",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_form_item, {
                      label: "Saldo Bancário",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          valor: _ctx.state.filtros.saldoBancario,
                          "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.filtros.saldoBancario) = $event)),
                          quantidadeCasasDecimais: 2
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_a_form_item, {
                      label: "Data base",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.state.filtros.dataBase,
                          "onUpdate:dataSelecionada": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.filtros.dataBase) = $event)),
                          horaMinutoSegundo: false,
                          disabled: false,
                          placeholder: ""
                        }, null, 8, ["dataSelecionada"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_form_item, {
                      label: "Quantidade de meses",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          valor: _ctx.state.filtros.quantidadeMeses,
                          "onUpdate:valor": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.filtros.quantidadeMeses) = $event)),
                          quantidadeCasasDecimais: 0
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_selecionar_conta, {
                  varios: true,
                  codigosSelecionados: _ctx.state.filtros.contas,
                  "onUpdate:codigosSelecionados": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.filtros.contas) = $event)),
                  empresas: _ctx.telaBase.empresasSelecionadas
                }, null, 8, ["codigosSelecionados", "empresas"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        (_ctx.state.resultado === null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_mensagem_sem_dados, null, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.formatarMoeda(_ctx.DTORelatorio.saldoBancario.saldoComLimites)), 1)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.formatarMoeda(_ctx.DTORelatorio.saldoBancario.saldoSemLimites)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DTORelatorio.despesasMensais.despesas, (desp, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "ss-sombra-suave ant-row",
                  style: {"min-height":"35px","padding-top":"5px"}
                }, [
                  _createElementVNode("div", _hoisted_35, "Despesas " + _toDisplayString(desp.periodo.length > 10 ? 'de ' : 'na Data ') + _toDisplayString(desp.periodo), 1),
                  _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.formatarMoeda(desp.valor)), 1)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.formatarMoeda(_ctx.DTORelatorio.despesasMensais.totalDespesasMes)), 1)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.formatarMoeda(_ctx.DTORelatorio.despesasMensais.saldoGeralSemLimites)), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.formatarMoeda(_ctx.DTORelatorio.previsaoRecebimento.cobSimples)), 1)
            ]),
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.formatarMoeda(_ctx.DTORelatorio.previsaoRecebimento.pedidosPendentes)), 1)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.formatarMoeda(_ctx.DTORelatorio.previsaoRecebimento.totalPrevisao)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.formatarMoeda(_ctx.DTORelatorio.duplicatasCarteira.carteiraDesconto180)), 1)
              ]),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.formatarMoeda(_ctx.DTORelatorio.duplicatasCarteira.carteiraDescontoMais180)), 1)
              ]),
              _createElementVNode("div", _hoisted_65, [
                _hoisted_66,
                _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.formatarMoeda(_ctx.DTORelatorio.duplicatasCarteira.totalCarteiraDesconto)), 1)
              ]),
              _createElementVNode("div", _hoisted_68, [
                _hoisted_69,
                _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.formatarMoeda(_ctx.DTORelatorio.duplicatasCarteira.totalPrevisaoMaisCarteira)), 1)
              ]),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, "Saldo Disponível para Pagamento de " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(_ctx.DTORelatorio.parametros.dataBase)), 1),
                _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.formatarMoeda(_ctx.DTORelatorio.duplicatasCarteira.saldoDisponivel)), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_74, [
          _hoisted_75,
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DTORelatorio.despesasFuturas.despesaFutura, (desp, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "ss-sombra-suave ant-row",
                  style: {"min-height":"35px","padding-top":"5px"}
                }, [
                  _createElementVNode("div", _hoisted_78, _toDisplayString(desp.mesAno), 1),
                  _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.formatarMoeda(desp.valor)), 1)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_80, [
                _hoisted_81,
                _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.formatarMoeda(_ctx.DTORelatorio.despesasFuturas.totalPagar)), 1)
              ]),
              _createElementVNode("div", _hoisted_83, [
                _createElementVNode("div", _hoisted_84, "Saldo em " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(_ctx.DTORelatorio.parametros.dataBase)), 1),
                _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.formatarMoeda(_ctx.DTORelatorio.despesasFuturas.saldoFinal)), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_86, [
          _hoisted_87,
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _hoisted_91,
                _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.formatarMoeda(_ctx.DTORelatorio.duplicatasCarteiraMaisUmAno.faturadosMaisUmAno)), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_93, [
          _hoisted_94,
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("div", _hoisted_98, "Saldo em " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(_ctx.DTORelatorio.parametros.dataBase)) + " + Faturado em Carteira", 1),
                _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.formatarMoeda(_ctx.DTORelatorio.saldoFuturo.saldoComFaturado)), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.arquivosPdf.length > 0)
      ? (_openBlock(), _createBlock(_component_preview_pdf, {
          key: 0,
          arquivos: _ctx.state.arquivosPdf,
          exibirDownload: true,
          onFechar: _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.arquivosPdf = []))
        }, null, 8, ["arquivos"]))
      : _createCommentVNode("", true)
  ], 64))
}